module.exports = __webpack_public_path__ + "img/gala-passport.fa68ad2f.svg";